module.exports = __webpack_public_path__ + "img/slack.d3d62126.png";